import { useState, useEffect, useRef } from 'react'
import useConfigOptions from '../../hooks/useConfigOptions';
import { useLoans } from '../../hooks';
import { HugeiconsIcon } from '@hugeicons/react';
import { ArrowDown01Icon, CheckmarkCircle01Icon } from '@hugeicons/core-free-icons';

function Filter({ endpoint, state, setLoading, setLoans, setMetadata, setFilteredLoanType }) {

    const { loanFilters } = useConfigOptions();
    const [loanType, setLoanType] = useState(loanFilters[0].value);
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    const { isLoading, loans, metadata } = useLoans(
        { loanType, state, active: false, completed: false, rejected: false, endpoint, page: null }
    );

    useEffect(() => {
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const handleSelect = (value) => {
        setLoanType(value);
        setFilteredLoanType(value);
        setOpen(false);
    };

    useEffect(() => {
        setLoading(isLoading);
        setLoans(loans);
        setMetadata(metadata);
    }, [isLoading, loans, metadata, setLoading, setLoans, setMetadata]);

    const selected = loanFilters.find(f => f.value === loanType) ?? loanFilters[0];

    return (
        <div className='relative flex items-center gap-2'>
            <span className='text-sm text-gray-500 dark:text-gray-400 hidden sm:block shrink-0'>Filter by</span>
            <div ref={ref} className='relative'>
                <button
                    onClick={() => setOpen(o => !o)}
                    className="flex items-center justify-between gap-2 px-3 py-1.5 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-sm font-medium text-gray-700 dark:text-gray-200 transition-colors min-w-[10rem]"
                >
                    <span>{selected.name}</span>
                    <HugeiconsIcon icon={ArrowDown01Icon} size={14} className={`text-gray-400 transition-transform shrink-0 ${open ? 'rotate-180' : ''}`} />
                </button>

                {open && (
                    <div className="absolute right-0 top-full mt-1.5 bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 py-1.5 z-50 min-w-[10rem] overflow-hidden">
                        {loanFilters.map((loan) => (
                            <button
                                key={loan.id}
                                onClick={() => handleSelect(loan.value)}
                                className={`w-full flex items-center justify-between gap-3 px-3 py-2 text-sm transition-colors ${
                                    loan.value === loanType
                                        ? 'text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-500/10 font-medium'
                                        : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
                                }`}
                            >
                                <span>{loan.name}</span>
                                {loan.value === loanType && (
                                    <HugeiconsIcon icon={CheckmarkCircle01Icon} size={15} className="text-blue-500 shrink-0" />
                                )}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default Filter;
